<template>
  <div class="order-item-container">
    <div class="ordernum-container">
      <span>订单号: {{ orderItem.order_no }}</span>
      <span style="float: right">{{
        orderItem.created_at | formatDate(false)
      }}</span>
    </div>
    <div class="order-content">
      <div class="order-info">
        <img :src="orderItem.goods ? orderItem.goods[0].image[0] : ''" alt="" />
        <div class="order-context">
          <div class="goods-name">
            {{ orderItem.goods ? orderItem.goods[0].name : "" }}
          </div>
          <div class="goods-category">
            {{ categoryStr }}
          </div>
        </div>
      </div>
      <div class="order-num">
        X {{ orderItem.goods ? orderItem.goods[0].count : "" }}
      </div>
      <div class="order-price">
        ￥{{ orderItem.goods ? orderItem.goods[0].price_sum : "" }}
      </div>
      <div class="order-btn">
        <div v-if="orderItem.status == -1">已取消</div>
        <div v-else-if="orderItem.status == 1">
          待支付<span class="pay-immediately" @click="toPayImmediately"
            >立即支付</span
          >
        </div>
        <div v-else-if="orderItem.status == 2">
          待发货<span class="pay-immediately" @click="toRemindDelivery"
            >提醒发货</span
          >
        </div>
        <div v-else-if="orderItem.status == 3">
          <div>
            待收货<span class="pay-immediately" @click="toConfirmRecepit"
              >确认收货</span
            >
          </div>
          <div>
            已发货<span class="pay-immediately" @click="toViewOrderDetail"
              >查看物流</span
            >
          </div>
        </div>
        <div
          style="margin-top: 6px"
          v-else-if="orderItem.status == 4"
          @click="toViewOrderDetail"
        >
          查看物流
        </div>
        <div style="margin-top: 6px" @click="toViewOrderDetail">订单详情</div>
      </div>
    </div>
    <PayDialog
      v-if="isShowPay"
      :confirmInfo="confirmInfo"
      @closeDialog="closePayDialog"
    ></PayDialog>
  </div>
</template>

<script>
import PayDialog from "@/views/ServiceMarket/payDialog.vue";
import { confirmReceipt } from "@/api/home";
export default {
  props: {
    orderItem: {
      type: Object,
      default: () => {},
    },
  },
  components: { PayDialog },
  data() {
    return {
      isShowPay: false,
      confirmInfo: null,
    };
  },
  computed: {
    categoryStr() {
      let str = "";
      if (this.orderItem.goods && this.orderItem.goods.length) {
        const spec = this.orderItem.goods[0].spec;
        for (const prop in spec) {
          str = `${prop}：${spec[prop]}`;
        }
      }
      return str;
    },
  },
  methods: {
    // 确认收货
    async toConfirmRecepit() {
      const resp = await confirmReceipt({
        order_no: this.orderItem.order_no,
      });
      if (resp.code === 10000) {
        this.$message.success("确认收货成功");
        this.$emit("changeTab", 4);
      }
    },
    // 提醒发货
    toRemindDelivery() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
        this.$message.success("已提醒商家发货");
      }, 2000);
    },
    closePayDialog() {
      this.confirmInfo = null;
      this.isShowPay = false;
    },
    //立即支付
    toPayImmediately() {
      this.confirmInfo = {
        orderNo: this.orderItem.order_no,
      };
      this.isShowPay = true;
      console.log(this.confirmInfo, "confirmInfo");
    },
    // 订单详情
    toViewOrderDetail() {
      this.$emit("viewDetail", this.orderItem);
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
.order-item-container {
  width: 100%;
  margin: 55px 0;
  box-sizing: border-box;
}
.ordernum-container {
  font-size: 14px;
  font-weight: 400;
  color: @tipwords;
  padding-bottom: 8px;
  box-sizing: border-box;
  border-bottom: 3px solid #e3e3e3;
}
.order-content {
  margin-top: 22px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.order-info {
  display: flex;
}
.order-info img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  margin-right: 26px;
}
.order-context {
  width: 321px;
}
.goods-name,
.order-num {
  font-size: 14px;
  font-weight: 600;
  color: @words;
}
.goods-name {
  .line-clamp();
}
.goods-category {
  margin-top: 21px;
  font-size: 12px;
  font-weight: 400;
  color: @tipwords;
  .line-clamp(1);
}
.order-price {
  font-size: 20px;
  font-weight: 600;
  color: @words;
}
.order-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.pay-immediately {
  margin-left: 6px;
  color: @primary;
}
</style>